var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('b',[_vm._v("TOTAL : "+_vm._s(_vm.totalList))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }